// extracted by mini-css-extract-plugin
module.exports = {"App":"styles_App__2Vxm3","app":"styles_App__2Vxm3","Main":"styles_Main__3m7Jb","main":"styles_Main__3m7Jb"};